// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"header_headerWrapper__qKZHh","title":"header_title__lJ0if"};